export const GA_VALUES = {
  events: {
    favourite: 'favourite',
    unfavourite: 'unfavourite',
    bannerCTAClicks: 'banner_cta_clicks'
  }
};
